import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Mutation } from 'react-apollo';

import { AuthContext } from '../../../context';

import mutations from '../../../graphql/mutations';

import style from './index.module.scss';

const {
  questionMutations: { QUESTION_ACTIONS_UPDATE },
} = mutations;

const formatAnswerInfo = answers => {
  if (answers.length === 0) {
    return 'Be the first to answer';
  } else if (answers.length === 1) {
    return '1 answer';
  } else {
    return `${answers.length} answers`;
  }
};

function Question({ question }) {
  const { currentUser } = useContext(AuthContext);
  const { action, title, icon } = style;
  const url = window.location.href;

  // Social share urls
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  const twitterUrl = `https://twitter.com/home?status=${url}`;

  return (
    <article className={`col-12 ${style.question}`}>
      <h3 className={title}>
        <Link
          to={{
            pathname: `/question/${encodeURI(question.title)}`,
            state: {
              questionId: question.id,
            },
          }}
          className={style['title-link']}
        >
          {question.title}
        </Link>
      </h3>
      <div className={`row ${style['row--info']}`}>
        <p className={`col-12 text-muted ${style['col--info']}`}>
          <Link
            to={{
              pathname: `/question/${encodeURI(question.title)}`,
              state: {
                questionId: question.id,
              },
            }}
            className={style['answers-link']}
          >
            <strong>{formatAnswerInfo(question.answers)}</strong>
          </Link>{' '}
          · Asked{' '}
          {question.createdAt === question.updatedAt
            ? moment(question.createdAt).format('LL')
            : moment(question.updatedAt).format('LL')}{' '}
          ·{' '}
          {!question.followedBy.length === 0 && (
            <span>Last Followed Jan 23, 2019</span>
          )}
        </p>
      </div>
      <div className={`row ${style['row--actions']}`}>
        <div
          className={`col-6 ${style['col--actions']} ${
            style['col--actions--left']
          }`}
        >
          <Link 
            to={{
              pathname: `/question/${encodeURI(question.title)}`,
              state: {
                questionId: question.id,
              }
            }} 
            className={action}
          >
            <i className='fas fa-edit' /> Answer
          </Link>
          <Mutation mutation={QUESTION_ACTIONS_UPDATE}>
            {(questionActionsUpdate, { loading, error, data }) => (
              <span
                className={action}
                onClick={() =>
                  questionActionsUpdate({
                    variables: {
                      input: {
                        questionId: question.id,
                        userId: currentUser.id,
                        updateType: 'follow',
                      },
                    },
                  })
                }
              >
                <i className='fas fa-rss' /> Follow {question.followedBy.length}
              </span>
            )}
          </Mutation>
        </div>
        <div
          className={`col-6 ${style['col--actions']} ${
            style['col--actions--right']
          }`}
        >
          <span>
            <i className={`fas fa-chevron-down ${icon}`} />
          </span>{' '}
          <a 
            href={facebookUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className={style['share--facebook']}
          >
            <i className={`fab fa-facebook ${icon}`} />
          </a>{' '}
          <a 
            href={twitterUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className={style['share--twitter']}
          >
            <i className={`fab fa-twitter ${icon}`} />
          </a>{' '}
          <span>
            <i className={`fas fa-share ${icon}`} />
          </span>
        </div>
      </div>
    </article>
  );
}

Question.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    followedBy: PropTypes.array.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  }).isRequired,
};

export default Question;
